export const ANNUAL = 'annual';
export const TWO_YEAR = '24month';
export const FAMILY = 'family';
export const GIFT = 'gift';
// Any future reference to trial should be TRIAL as defined in constants/maverick unless otherwise noted
export const TRIAL_DEPRECATED = 'trial';

export const validBNPLRegions = ['US', 'EU', 'UK'];
